import { getProfile } from './localStorage';

const BYPASS_USER_TYPES = ['super_user', 'admin-company'];

/**
 * ซ่อนปุ่มตามสิทธิ์ (create / update / delete ฯลฯ)
 * super_user / admin-company เห็นทุกปุ่ม เหมือนหน้า portal / PermissionRoute
 * ปุ่มที่ซ่อนแล้ว backend ยังตรวจสิทธิ์ซ้ำเสมอ (403 -> alert ไม่มีสิทธิ์ใช้งาน)
 */
export const can = (key) => {
  const profile = getProfile();
  if (BYPASS_USER_TYPES.includes(profile?.user_type)) return true;
  return (profile?.role?.permission || []).includes(key);
};

/** ผ่านถ้ามีอย่างน้อยหนึ่ง key */
export const canAny = (...keys) => keys.flat().some((key) => can(key));
